import { z } from 'zod'

export const coachingPlatformOrganizationRoleSchema = z.enum(['admin', 'super_admin'])

export const coachingPlatformOrganizationCreateRequestSchema = z.object({
  name: z.string().trim().min(1).max(240),
  firstAdmin: z.object({
    email: z.string().trim().email().max(320),
    firstName: z.string().trim().max(120).optional(),
    lastName: z.string().trim().max(120).optional(),
  }),
  role: coachingPlatformOrganizationRoleSchema.default('admin'),
})

export const coachingPlatformOrganizationCreateResponseSchema = z.object({
  orgId: z.string(),
  name: z.string(),
  firstAdminUserId: z.string(),
  creatorUserId: z.string(),
  creatorRole: z.literal('super_admin'),
  inviteStatus: z.enum(['sent', 'not_sent']),
  inviteUrl: z.string().url(),
  replayed: z.boolean().optional(),
})

export const coachingPlatformOrganizationCountsSchema = z.object({
  companies: z.number().int().nonnegative(),
  cohorts: z.number().int().nonnegative(),
  activeParticipants: z.number().int().nonnegative(),
  staffHolders: z.number().int().nonnegative(),
})

export const coachingPlatformOrganizationSchema = z.object({
  orgId: z.string(),
  name: z.string(),
  created_at: z.string(),
  counts: coachingPlatformOrganizationCountsSchema,
  coachingRole: z.enum(['super_admin', 'admin', 'coach', 'company_admin', 'cohort_lead', 'participant']).nullable(),
})

export const coachingPlatformOrganizationsListResponseSchema = z.object({
  organizations: z.array(coachingPlatformOrganizationSchema),
})

export type CoachingPlatformOrganizationRole = z.infer<typeof coachingPlatformOrganizationRoleSchema>
export type CoachingPlatformOrganizationCreateRequest = z.infer<typeof coachingPlatformOrganizationCreateRequestSchema>
export type CoachingPlatformOrganizationCreateResponse = z.infer<typeof coachingPlatformOrganizationCreateResponseSchema>
export type CoachingPlatformOrganizationCounts = z.infer<typeof coachingPlatformOrganizationCountsSchema>
export type CoachingPlatformOrganization = z.infer<typeof coachingPlatformOrganizationSchema>
export type CoachingPlatformOrganizationsListResponse = z.infer<typeof coachingPlatformOrganizationsListResponseSchema>
